import React from 'react';
import ReactDOM from 'react-dom/client';
import '@quyva/shared-ui/dist/index.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    AuthProvider,
    AdminProvider,
    DefaultPromptProvider,
    FeatureFlagsProvider,
} from './context';
import { GlobalStateProvider } from './context/GlobalStateContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    //     <AuthProvider>
    //         <GlobalStateProvider>
    //             <App />
    //         </GlobalStateProvider>
    //     </AuthProvider>
    // </React.StrictMode>
    <GlobalStateProvider>
        <AuthProvider>
            <FeatureFlagsProvider>
                <AdminProvider>
                    <DefaultPromptProvider>
                        <App />
                    </DefaultPromptProvider>
                </AdminProvider>
            </FeatureFlagsProvider>
        </AuthProvider>
    </GlobalStateProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
